<div
  class="slider"
  #slider
  [ngClass]="{ 'initial-background': disableDropDownOptions() }"
  data-automation="datatable-slider-container"
>
  <span
    class="slider__pointer"
    #pointer
    [style.left]="pointerLeftPosition()"
    [ngStyle]="{ 'font-size': fontSize() }"
    data-automation="datatable-slider-pointer"
  >
    {{ value() }}
  </span>
  <input
    type="range"
    class="slider__input"
    [min]="min()"
    [max]="max()"
    [step]="step()"
    [value]="value()"
    [ngStyle]="{ background: sliderProgressStyling() }"
    (input)="updateValue($event)"
    data-automation="datatable-slider"
  />
</div>
